import type { GeneralSkinGetter } from '../../skins/skins.types';

export const getSectionLikeActionsSkin: GeneralSkinGetter = (
  editorAPI,
  compRef,
) => {
  return editorAPI.components.is.siteSegment(compRef)
    ? 'legacy-soap'
    : 'legacy';
};
